import React, { useRef, useState } from "react";
import { string } from "prop-types";

import { HIDDEN_LABEL, PLACEHOLDER, VALIDATION_ERROR } from "./constants";
import * as S from "./styled";

let index = 0;

const Search = ({ placeholder }) => {
  const [hasValidationError, setHasValidationError] = useState(false);
  const searchInputRef = useRef(null);
  const searchInputId = useRef(null);
  const searchTextRef = useRef("");
  const handleInputChange = event => {
    searchTextRef.current = event?.target?.value || "";
  };
  const handleFormSubmit = event => {
    const navSearchInput = searchInputRef.current;
    const submittedText = searchTextRef.current.trim();
    const SE = window?.SE;

    if (SE?.analytics?.submitTextSearch) {
      SE.analytics.submitTextSearch(searchTextRef.current);
    }

    if (
      submittedText.length === 0 ||
      submittedText === "Search" ||
      submittedText === "address, building, agent"
    ) {
      event.preventDefault();
      navSearchInput.focus();
      setHasValidationError(true);
    }
  };

  // Used for multiple search input to set unique id
  if (searchInputId.current === null) {
    index += 1;
    searchInputId.current = `search_nav-${index}`;
  }

  return (
    <>
      <S.SearchForm
        acceptCharset="UTF-8"
        action="/search"
        method="get"
        onSubmit={handleFormSubmit}
      >
        <input name="utf8" type="hidden" value="✓" />
        <S.SearchLabel htmlFor={searchInputId.current}>
          {placeholder}
        </S.SearchLabel>
        <S.SearchInput
          ref={searchInputRef}
          autocomplete="on"
          id={searchInputId.current}
          name="search"
          onChange={handleInputChange}
          placeholder={placeholder}
          type="text"
        />
        <S.SearchButton aria-label="Search" name="commit">
          <S.SearchButtonLabel className="u-visuallyHidden">
            {HIDDEN_LABEL}
          </S.SearchButtonLabel>
        </S.SearchButton>
      </S.SearchForm>

      {hasValidationError && (
        <S.ValidationErrorToast
          icon="warning"
          isAutoWidth
          message={VALIDATION_ERROR}
          offsetY={120}
          onHide={() => setHasValidationError(false)}
          theme="red"
          time={3000}
        />
      )}
    </>
  );
};

Search.propTypes = {
  placeholder: string
};

Search.defaultProps = {
  placeholder: PLACEHOLDER
};

export default Search;
